import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import UndoIcon from "@mui/icons-material/Undo";
import Modal from "@mui/material/Modal";
// Components
import MuiHeader from "../../components/MuiHeader";
import MuiLoader from "../../components/MuiLoader";

// Thunks
import {
  getAllProgramTypes,
  getAllModules,
  getAllsubModules,
  getAllTopics,
} from "../PedagogySection/Pedagogy.Thunk";
import {
  createAssessmentModule,
  createPptSubModule,
  createPptTopic,
  deletePptModule,
  deletePptSubModule,
  deletePptTopic,
  updatePptModule,
  updatePptSubModule,
  updatePptTopic,
} from "./PedagogyModule.Thunk";
// MUI
import {
  Avatar,
  Button,
  InputLabel,
  FormControl,
  Select,
  TextField,
  Box,
  Grid,
  Card,
  CardHeader,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  CircularProgress,
  ListItemButton,
  Slide,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AodIcon from "@mui/icons-material/Aod";
import { red, blue, green, purple } from "@mui/material/colors";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import FolderIcon from "@mui/icons-material/Folder";
import DeleteIcon from "@mui/icons-material/Delete";
// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// swal
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import api from "../../api/api";
import { deleteFileFromDB, UploadFileToAzureDB } from "../../components/Azure";
import { getMediaUrl } from "../../utils/mediaUtils";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function PptModulesPage() {
  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     const message = "Are you sure you want to leave?";
  //     event.returnValue = message; // Standard for most browsers
  //     return message; // For some older browsers
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   window.addEventListener("unload", handleReload);

  //   return () => {
  //     // Cleanup event listeners when the component is unmounted
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //     window.removeEventListener("unload", handleReload);
  //   };
  // }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [usertype, setUsertype] = useState("fellow");
  const [modules, setModules] = useState([]);
  console.log("modules--------->", modules);
  const [moduleorder, setModuleorder] = useState();
  const [submodules, setSubmodules] = useState([]);
  const [topic, setTopic] = useState([]);
  const [selModuleDetails, setSelModuleDetails] = useState("");
  const [selSubModuleDetails, setSelSubModuleDetails] = useState({});
  const [topics, setTopics] = useState([]);
  const [programtype, setProgramtype] = useState("");
  const [programData, setProgramData] = useState([]);
  const [submoduleDuration, setSubmoduleDuration] = useState();
  const [topicDuration, setTopicDuration] = useState();

  const [selectedImage, setSelectedImage] = useState(null);
  const [imageName, setImageName] = useState("");
  const [fileExtensionType, setFileExtensionType] = useState("");
  const [file, setFile] = useState("");
  const [imgUrl, setImgUrl] = useState("");

  // --------- options for dropdowns ---------
  const language_select_option_list = [
    //
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];
  const usertype_select_option_list = [
    { value: "fellow", text: "Educator" },
    { value: "anganwadi", text: "Anganwadi" },
    { value: "school", text: "School" },
    { value: "cci", text: "CCI" },
  ];

  const trainingTypeArray =
    usertype === "fellow"
      ? [
          {
            trainingType: "training1",
            trainingName: "21st Century Skills",
          },
          {
            trainingType: "training2",
            trainingName: "Technology",
          },
          {
            trainingType: "training3",
            trainingName: "Pedagogy",
          },
        ]
      : [
          {
            trainingType: "training1",
            trainingName: "21st Century Skills",
          },

          {
            trainingType: "training3",
            trainingName: "Pedagogy",
          },
        ];

  //^------------------Select an image from the device---------------------------------
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const maxHeight = 612;
    const maxWidth = 612;

    if (file) {
      const fileExtension = file.name.split(".").pop().toLowerCase();
      const fileType = file.type;

      if (file.size > 1048578) {
        toast.error("File size exceeds the maximum allowed (1 MB)");
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;

        img.onload = async () => {
          const { width, height } = img;
          // console.log("fileSizes--------------------->", width, height);

          if (width > maxWidth || height > maxHeight) {
            toast.error("Maximum height and width exceeded");
            return;
          }

          if (fileExtension === "png" || fileType === "image/png") {
            setFileExtensionType("png");
            setImageName(`trainMod_${new Date().getTime()}.png`);
          } else if (
            fileExtension === "jpg" ||
            fileExtension === "jpeg" ||
            fileType === "image/jpeg"
          ) {
            setFileExtensionType("jpg");
            setImageName(`trainMod_${new Date().getTime()}.jpg`);
          } else {
            console.log("It is neither a PNG nor a JPG file.");
            return;
          }

          setSelectedImage(file);
          setFile(e.target.result);
        };
      };

      reader.readAsDataURL(file);
    }
  };

  const ITEM_HEIGHT = 48;

  const [preferedlanguage, setPreferedlanguage] = useState("od");
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [recordId, setRecordId] = useState("");
  const [selectedSkillsetId, setSelectedSkillsetId] = useState("");
  const [selectedSkillsetName, setSelectedSkillsetName] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [dense, setDense] = React.useState(false);
  const [secondary, setSecondary] = React.useState(false);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, _id, skillsetid, skillsetname, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setRecordId(_id);
    setSelectedSkillsetId(skillsetid);
    setSelectedSkillsetName(skillsetname);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
  };

  const navigate_to = () => {
    navigate("/pedagogy");
  };
  // get all modules all on page load, update and delete
  useEffect(() => {
    const body = {
      usertype: "fellow",
      language: preferedlanguage,
    };
    getAllProgramTypes(body)
      .then((modules) => {
        ////console.log(modules.data, "modules");
        setProgramData(modules.data);
      })
      .catch((error) => {
        console.error("The error is--------------->", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
  }, []);

  // ------------ Load data & skill ----------------
  const submoduleDuration_select_onChange = (e) => {
    setSubmoduleDuration(e.target.value);
  };
  // -----------------------------------------------

  // ----------- create, update delete button click ----------

  // on language change
  const preflanguage_select_onchange = (e) => {
    if (!e.target.value) {
      setPreferedlanguage("");
      setUsertype("");
      setProgramData("");
      setProgramtype("");
    } else {
      setPreferedlanguage(e.target.value);
      setUsertype("");
      setProgramtype("");
    }
  };

  //on usertype change
  const usertype_select_onchange = (event) => {
    if (!event.target.value) {
      setUsertype("");
      setProgramData("");
      setProgramtype("");
    } else {
      setUsertype(event.target.value);
      setProgramtype("");
      const body = {
        usertype: event.target.value,
        language: preferedlanguage,
      };
      if (preferedlanguage && event.target.value) {
        getAllProgramTypes(body)
          .then((modules) => {
            ////console.log(modules.data, "modules");
            setProgramData(modules.data);
          })
          .catch((error) => {
            console.error("The error is--------------->", error);
            if (error.response.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              console.error("An unexpected error occurred:", error);
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
          });
      }
    }
  };
  // //console.log("usertype--------->", usertype);
  // //console.log("language--------->", preferedlanguage);
  // //console.log("all program data---------->", programData);
  // //console.log("training type--------->", programtype);

  let trainingNameChosen = "";
  const allPrograms = trainingTypeArray
    ? trainingTypeArray.filter((item) => item.trainingType === programtype)
    : [];

  // //console.log("allPrograms--------->", allPrograms);
  trainingNameChosen = allPrograms[0]?.trainingName;
  // //console.log("trainingName sent---------->", trainingNameChosen);
  // //console.log("trainingType sent--------->", programtype);

  //onProgramtype change
  const program_select_onchange = (e) => {
    if (!e.target.value) {
      setProgramtype("");
    } else {
      setProgramtype(e.target.value);
      const data = {
        trainingType: e.target.value,
        usertype: usertype,
        language: preferedlanguage,
      };
      if (e.target.value) {
        getAllModules(data)
          .then((modules) => {
            setModules(modules.data);
          })
          .catch((error) => {
            console.error("The error is--------------->", error);
            if (error.response.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              console.error("An unexpected error occurred:", error);
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
          });
      } else {
        setModules("");
      }
    }
  };

  const deleteImageForUpdate = (item) => {
    deleteFileFromDB(item.moduleImage);
    setUpdateData({ ...updateData, moduleImage: "" });
  };

  //on delete module
  const moduleDelete_clicked = (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteFileFromDB(e.moduleImage);
        deletePptModule(e.moduleId)
          .then(() => {
            // Module deleted successfully, now fetch all available modules
            const body = {
              usertype: usertype,
              language: preferedlanguage,
              trainingType: programtype,
            };
            getAllModules(body) // Assuming getAllModules is implemented correctly to fetch modules data
              .then((modules) => {
                setModules(modules.data);
                toast.success("Module deleted successfully and data fetched");
              })
              .catch((error) => {
                console.error("Error fetching modules:", error);
                if (error.response.status === 500) {
                  toast.error("Internal server error.");
                } else if (error.response.status === 504) {
                  toast.error("Server timeout. Please try again later.");
                } else {
                  console.error("An unexpected error occurred:", error);
                  toast.error(
                    "An unexpected error occurred. Please try again later."
                  );
                }
              });
          })
          .catch((error) => {
            console.error("Error deleting module:", error);
            if (error.response.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              console.error("An unexpected error occurred:", error);
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
          });
      }
    });
  };

  const [updateData, setUpdateData] = useState({
    moduleId: new Date().getTime(),
    moduleName: "",
    moduleOrder: "",
    moduleDuration: "",
    moduleDescription: "",
    moduleImage: "",
  });
  // //console.log("updateData-->", updateData);

  const [updationValues, setUpdationValues] = useState([]);
  const [showUpdate, setShowUpdate] = useState(false);
  const [updateExtra, setUpdateExtra] = useState([]);
  const handleShowUpdate = (eachskill) => {
    const valueSentForUpdation = modules.filter(
      (obj) => obj.moduleId === eachskill.moduleId
    );
    setUpdationValues(valueSentForUpdation);
    setUpdateExtra(eachskill);
    setUpdateData({
      moduleId: eachskill.moduleId,
      moduleName: eachskill.moduleName,
      moduleOrder: eachskill.moduleOrder,
      moduleDuration: eachskill.moduleDuration,
      moduleDescription: eachskill.moduleDescription,
      moduleImage: eachskill.moduleImage,
      usertype: usertype,
    }); //
    // //console.log("updateData----------->", updateData);
    setShowUpdate(true);
  };
  const handleCloseUpdate = () => {
    if (
      updateData.moduleImage !== "" &&
      updateData?.moduleImage !== updationValues[0]?.moduleImage
    ) {
      setShowUpdate(false);
    } else if (
      updateData.moduleImage &&
      updateData.moduleDescription &&
      updateData.moduleOrder &&
      updateData.moduleName &&
      updateData.moduleDuration
    ) {
      setShowUpdate(false);
    } else {
      toast.error("Sorry, you must have all the fields");
    }
  };

  const handleUpdateChange = async (item) => {
    let finalImageUrl = item.moduleImage;

    if (file) {
      const uploadResult = await UploadFileToAzureDB(selectedImage, imageName);
      if (uploadResult?.success && uploadResult?.url) {
        finalImageUrl = uploadResult.url;
      } else {
        return; // Upload failed, toast already handled inside UploadFileToAzureDB
      }
    }

    const body = {
      moduleId: item.moduleId,
      moduleName: item.moduleName,
      moduleOrder: item.moduleOrder,
      moduleDuration: item.moduleDuration,
      moduleDescription: item.moduleDescription,
      moduleImage: finalImageUrl,
      usertype: usertype,
      trainingType: programtype,
      language: preferedlanguage,
      trainingName: item.trainingName,
    };
    updatePptModule(body)
      .then((response) => {
        if (response && response.status === 200) {
          const body = {
            usertype: usertype,
            language: preferedlanguage,
            trainingType: programtype,
          };
          if (preferedlanguage && usertype && programtype) {
            getAllModules(body)
              .then((modules) => {
                setModules(modules.data);
                toast.success("Module updated successfully");
                setFile("");
                setSelectedImage(null);
                setImageName("");
              })
              .catch((error) => {
                if (error.response && error.response.status === 413) {
                  toast.error("The file is too large to upload");
                  console.error("The error is:", error);
                } else if (error.response && error.response.status === 500) {
                  toast.error("Internal server error.");
                } else if (error.response && error.response.status === 504) {
                  toast.error("Server timeout. Please try again later.");
                } else {
                  console.error("Error fetching modules:", error);
                  toast.error("Error fetching modules. Please try again.");
                }
              });
          } else {
            setModules("");
          }
        } else {
          console.error("Update failed with response:", response);
          toast.error("Failed to update module. Please try again.");
        }
      })
      .catch((error) => {
        console.error("Error updating module:", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
    setShowUpdate(false);
  };

  //on create module
  const [moduleDuration, setModuleDuration] = useState();
  // //console.log("moduleDuration==>", moduleDuration);
  const moduleDuration_select_onchange = (event) => {
    if (
      event.target.value &&
      typeof parseInt(event.target.value) !== "number"
    ) {
      toast.error("Duration should be in number");
      setModuleDuration("");
    } else {
      setModuleDuration(event.target.value);
    }
  };

  const submoduleOrder_select_onChange = (event) => {
    setSubmoduleOrder(event.target.value);
  };

  const moduleorder_select_onchange = (event) => {
    setModuleorder(event.target.value);
  };

  const [modulename, setModulename] = useState("");
  // //console.log("modulename===>", modulename);
  const module_create_onChange = (event) => {
    setModulename(event.target.value);
  };

  // -------------------------------------------------
  //sub modules
  const submoduleEdit_clicked = (e) => {
    Swal.fire({
      title: "UPDATE SUBMODULES",
      html: `
      <label>Submodule Name </label>
      <input id="name" class="swal2-input" placeholder="Order" value="${e.submoduleName}">
      <label>Submodule Order </label>
      <input id="order" class="swal2-input" placeholder="Order" value="${e.submoduleOrder}"> <br>
      <label>Submodule Duration </label>
      <input id="duration" class="swal2-input" placeholder="Duration" value="${e.submoduleDuration}">
      <label>Description</label>
      <input id="description" class="swal2-input" placeholder="Description" value="${e.submoduleDescription}">
    `,
      showCancelButton: true,
      confirmButtonText: "Update",
      showLoaderOnConfirm: true,
      preConfirm: (input_value) => {
        const subModuleNameInput = Swal.getPopup().querySelector("#name");
        const orderInput = Swal.getPopup().querySelector("#order");
        const durationInput = Swal.getPopup().querySelector("#duration");
        const submoduleDescriptionInput =
          Swal.getPopup().querySelector("#description");
        const newsubModulename = subModuleNameInput.value;
        const submoduleOrder = orderInput.value;
        const submoduleDuration = durationInput.value;
        const submoduleDescription = submoduleDescriptionInput.value;
        if (input_value === e.submoduleName) {
          toast.error("No changes made");
          return;
        } else if (!input_value) {
          toast.error("Enter a valid skillset name");
          return;
        }

        const data = {
          submoduleId: e.submoduleId,
          submoduleName: newsubModulename,
          submoduleDuration: parseInt(submoduleDuration),
          submoduleOrder: parseInt(submoduleOrder),
          submoduleDescription: submoduleDescription,
        };

        updatePptSubModule(data)
          .then((response) => {
            const data = {
              usertype: usertype,
              language: preferedlanguage,
              moduleid: selModuleDetails.moduleId,
              trainingType: programtype,
            };

            getAllsubModules(data)
              .then((submodules) => {
                setSubmodules(submodules.data);
                toast.success("Submodule updated successfully");
              })
              .catch((error) => {
                console.error("Error fetching submodules:", error);

                if (error.response.status === 500) {
                  toast.error("Internal server error.");
                } else if (error.response.status === 504) {
                  toast.error("Server timeout. Please try again later.");
                } else {
                  console.error("An unexpected error occurred:", error);
                  toast.error(
                    "An unexpected error occurred. Please try again later."
                  );
                }
              });
          })
          .catch((error) => {
            console.error("Error updating submodule:", error);
            if (error.response.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              console.error("An unexpected error occurred:", error);
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
          });
      },
    });
  };

  const submoduleDelete_clicked = (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deletePptSubModule(e.submoduleId)
          .then((response) => {
            if (response && response.status == 200) {
              const data = {
                usertype: usertype,
                language: preferedlanguage,
                trainingType: programtype,
                moduleid: selModuleDetails.moduleId,
              };

              getAllsubModules(data).then((submodules) => {
                setSubmodules(submodules.data);
                toast.success("Changes made successfully");
              });
            }
          })
          .catch((error) => {
            console.error("The error is--------------->", error);
            if (error.response.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              console.error("An unexpected error occurred:", error);
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
          });
      }
    });
  };

  const module_select_onchange = (e) => {
    const data = {
      usertype: usertype,
      language: preferedlanguage,
      moduleid: e.target.value.moduleId,
      trainingType: programtype,
    };

    setSelModuleDetails(e.target.value);
    if (modules) {
      getAllsubModules(data)
        .then((submodules) => {
          // //console.log(submodules.data, "modules");
          setSubmodules(submodules.data);
        })
        .catch((error) => {
          console.error("The error is--------------->", error);
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
        });
    } else {
      setSubmodules("");
    }
  };

  const quizMediaFileRef = useRef();

  const [accept, setAccept] = useState("");
  const [showUploadPanel, setShowUploadPanel] = useState(false);
  const [questionMedia, setQuestionMedia] = useState("");

  const [questionMediaFile, setQuestionMediaFile] = useState(null);

  const handleModuleSave = async () => {
    setLoading(true);
    if (
      moduleorder === undefined ||
      moduleorder === null ||
      moduleorder.length <= 0 ||
      modulename === undefined ||
      modulename === null ||
      modulename.length <= 0 ||
      !mdescription ||
      mdescription.length <= 0
    ) {
      toast.error("Select all the fields");
      setLoading(false);
    } else if (!imageName) {
      toast.error("Please select an image before proceeding!");
      setLoading(false);
    } else {
      const uploadResult = await UploadFileToAzureDB(selectedImage, imageName);
      if (!uploadResult?.success) {
        setLoading(false);
        return;
      }

      const data = {
        usertype: usertype,
        language: preferedlanguage,
        trainingType: programtype,
        moduleId: new Date().getTime(),
        moduleName: modulename,
        moduleOrder: parseInt(moduleorder),
        moduleDuration: moduleDuration,
        trainingName: trainingNameChosen,
        moduleDescription: mdescription,
        moduleImage: uploadResult.url || imageName,
      };
      const res = await createAssessmentModule(data);
      if (programtype) {
        const body = {
          usertype: usertype,
          language: preferedlanguage,
          trainingType: programtype,
        };
        const modules = await getAllModules(body);
        setModules(modules.data);
        toast.success("Module created successfully");
        setLoading(false);

        setModuleorder("");
        setModulename("");
        setModuleDuration("");
        setMdescription("");
        setOpenModal(false);
        setFile("");
        setImageName("");
        setSelectedImage(null);
        setFileExtensionType("");
      } else {
        setModules("");
      }
    }
  };

  const [submoduleOrder, setSubmoduleOrder] = useState("");
  const [submoduleName, setSubmoduleName] = useState("");
  const submoduleName_select_onChange = (event) => {
    setSubmoduleName(event.target.value);
  };

  const handleSubmoduleSave = () => {
    const data = {
      language: preferedlanguage,
      moduleOrder: selModuleDetails.moduleOrder,
      moduleName: selModuleDetails.moduleName,
      trainingName: trainingNameChosen,
      usertype: usertype,
      trainingType: programtype,
      moduleId: selModuleDetails.moduleId,
      moduleDuration: selModuleDetails.moduleDuration,
      submoduleId: new Date().getTime(),
      submoduleName: submoduleName,
      submoduleOrder: submoduleOrder,
      submoduleDuration: submoduleDuration,
      submoduleDescription: sdescription,
      moduleDescription: selModuleDetails.moduleDescription,
      moduleImage: selModuleDetails.moduleImage,
    };

    if (
      submoduleOrder === undefined ||
      submoduleOrder === null ||
      submoduleOrder.length <= 0 ||
      submoduleName === undefined ||
      submoduleName === null ||
      submoduleName.length <= 0 ||
      !sdescription ||
      sdescription.length <= 0
    )
      toast.error("Select all the fields !");
    else {
      createPptSubModule(data)
        .then((response) => {
          // if (response.data.status == "success") {
          const data = {
            usertype: usertype,
            language: preferedlanguage,
            trainingType: programtype,
            moduleid: selModuleDetails.moduleId,
          };
          if (modules) {
            getAllsubModules(data).then((submodules) => {
              setSubmodules(submodules.data);
              toast.success("Changes made successfully");
              setSubmoduleOrder("");
              setSubmoduleName("");
              setSubmoduleDuration("");
              setSdescription("");
            });
            setOpenSubModal(false);
          } else {
            setSubmodules("");
          }
        })
        .catch((error) => {
          console.error("The error is--------------->", error);
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
        });
    }
  };

  const topicEdit_clicked = (e) => {
    Swal.fire({
      title: "UPDATE SKILLSET",
      html: `
      <label>Topic Name </label>
      <input id="name" class="swal2-input" placeholder="Order" value="${e.topicName}">
      <label>Topic Order </label>
      <input id="order" class="swal2-input" placeholder="Order" value="${e.topicOrder}"> <br>
      <label>Topic Duration </label>
      <input id="duration" class="swal2-input" placeholder="Duration" value="${e.topicDuration}">
      <label>Description </label>
      <input id="description" class="swal2-input" placeholder="Description" value="${e.topicDescription}">
    `,
      showCancelButton: true,
      confirmButtonText: "Update",
      showLoaderOnConfirm: true,
      preConfirm: (input_value) => {
        const topicNameInput = Swal.getPopup().querySelector("#name");
        const orderInput = Swal.getPopup().querySelector("#order");
        const durationInput = Swal.getPopup().querySelector("#duration");
        const descriptionInput = Swal.getPopup().querySelector("#description");

        const newTopicName = topicNameInput.value;
        const topicOrderinput = orderInput.value;
        const topicDuration = durationInput.value;
        const topicdescription = descriptionInput.value;
        if (input_value === e.topicName) toast.error("No changes made");
        else if (
          input_value === undefined ||
          input_value === null ||
          input_value.length <= 0
        )
          toast.error("Enter a valid skillset name");
        else {
          //update function
          const data = {
            topicId: e.topicId,
            topicName: newTopicName,
            topicDuration: parseInt(topicDuration),
            topicOrder: parseInt(topicOrderinput),
            topicDescription: topicdescription,
          };
          updatePptTopic(data).then((response) => {
            if (response && response.status == 200) {
              const data = {
                usertype: usertype,
                language: preferedlanguage,
                trainingType: programtype,
                moduleid: selModuleDetails.moduleId,
                moduleName: selModuleDetails.moduleName,
                submoduleid: selSubModuleDetails.submoduleId,
              };
              getAllTopics(data)
                .then((topic) => {
                  setTopics(topic.data);
                  toast.success("Changes made successfully");
                })
                .catch((error) => {
                  console.error("The error is--------------->", error);
                  if (error.response.status === 500) {
                    toast.error("Internal server error.");
                  } else if (error.response.status === 504) {
                    toast.error("Server timeout. Please try again later.");
                  } else {
                    console.error("An unexpected error occurred:", error);
                    toast.error(
                      "An unexpected error occurred. Please try again later."
                    );
                  }
                });
            }
          });
        }
      },
    });
  };
  const topicDelete_clicked = (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        deletePptTopic(e.topicId)
          .then((response) => {
            if (response && response.status == 200) {
              const data = {
                usertype: usertype,
                language: preferedlanguage,
                trainingType: programtype,
                moduleid: selModuleDetails.moduleId,
                moduleName: selModuleDetails.moduleName,
                submoduleid: selSubModuleDetails.submoduleId,
              };
              getAllTopics(data).then((topic) => {
                setTopics(topic.data);
                toast.success("Changes made successfully");
              });
            }
          })
          .catch((error) => {
            console.error("The error is--------------->", error);
            if (error.response.status === 500) {
              toast.error("Internal server error.");
            } else if (error.response.status === 504) {
              toast.error("Server timeout. Please try again later.");
            } else {
              console.error("An unexpected error occurred:", error);
              toast.error(
                "An unexpected error occurred. Please try again later."
              );
            }
          });
      }
    });
  };

  const [topicOrder, setTopicOrder] = useState("");

  const topicOrder_select_onchange = (event) => {
    setTopicOrder(event.target.value);
  };
  const [topicName, setTopicName] = useState("");
  const topicName_select_onchange = (event) => {
    setTopicName(event.target.value);
  };

  const topicDuration_select_onchange = (event) => {
    setTopicDuration(event.target.value);
  };

  const handleTopicSave = () => {
    const data = {
      language: preferedlanguage,
      usertype: usertype,
      trainingType: programtype,
      trainingName: trainingNameChosen,
      moduleId: selModuleDetails.moduleId,
      moduleName: selModuleDetails.moduleName,
      moduleOrder: selModuleDetails.moduleOrder,
      moduleDuration: selModuleDetails.moduleDuration,
      submoduleId: selSubModuleDetails.submoduleId,
      submoduleName: selSubModuleDetails.submoduleName,
      submoduleOrder: selSubModuleDetails.submoduleOrder,
      submoduleDuration: selSubModuleDetails.submoduleDuration,
      topicId: new Date().getTime().toString(),
      topicName: topicName,
      topicOrder: parseInt(topicOrder),
      topicDuration: topicDuration,
      moduleDescription: selModuleDetails.moduleDescription,
      topicDescription: tdescription,
      submoduleDescription: selSubModuleDetails.submoduleDescription,
      moduleImage: selModuleDetails.moduleImage,
    };

    if (
      topicOrder === undefined ||
      topicOrder === null ||
      topicOrder.length <= 0 ||
      topicName === undefined ||
      topicName === null ||
      topicName.length <= 0 ||
      !tdescription ||
      tdescription.length <= 0
    )
      toast.error("Select all the fields !");
    else {
      createPptTopic(data)
        .then((response) => {
          // if (response.data.status == 201) {
          const data = {
            usertype: usertype,
            language: preferedlanguage,
            trainingType: programtype,
            moduleid: selModuleDetails.moduleId,
            moduleName: selModuleDetails.moduleName,
            // moduleOrder: "",
            submoduleid: selSubModuleDetails.submoduleId,
          };
          getAllTopics(data).then((topic) => {
            setTopics(topic.data);
            toast.success("Changes made successfully");
            setTopicOrder("");
            setTopicName("");
            setTopicDuration("");
            setTdescription("");
            // setSelSubModuleDetails("");
          });
          setOpenTopModal(false);
        })
        .catch((error) => {
          console.error("The error is--------------->", error);
          if (error.response.status === 500) {
            toast.error("Internal server error.");
          } else if (error.response.status === 504) {
            toast.error("Server timeout. Please try again later.");
          } else {
            console.error("An unexpected error occurred:", error);
            toast.error(
              "An unexpected error occurred. Please try again later."
            );
          }
        });
    }
  };

  const submodule_select_onchange = (e) => {
    const data = {
      usertype: usertype,
      language: preferedlanguage,
      trainingType: programtype,
      moduleid: selModuleDetails.moduleId,
      submoduleid: e.target.value.submoduleId,
    };
    setSelSubModuleDetails(e.target.value);
    getAllTopics(data)
      .then((topic) => {
        setTopics(topic.data);
      })
      .catch((error) => {
        console.error("The error is--------------->", error);
        if (error.response.status === 500) {
          toast.error("Internal server error.");
        } else if (error.response.status === 504) {
          toast.error("Server timeout. Please try again later.");
        } else {
          console.error("An unexpected error occurred:", error);
          toast.error("An unexpected error occurred. Please try again later.");
        }
      });
  };

  //----------------------Description section----------------------
  const [mdescription, setMdescription] = useState("");
  const change_DescriptionM = (e) => {
    setMdescription(e.target.value);
  };

  const [sdescription, setSdescription] = useState("");
  const change_DescriptionS = (e) => {
    setSdescription(e.target.value);
  };

  const [tdescription, setTdescription] = useState("");
  const change_DescriptionT = (e) => {
    setTdescription(e.target.value);
  };

  const [openModal, setOpenModal] = useState(false);
  const openModalCreate = () => {
    setOpenModal(true);
  };
  const closeModal = () => {
    setOpenModal(false);
    setModulename("");
    setModuleorder("");
    setModuleDuration("");
    setMdescription("");
    setQuestionMedia("");
    setQuestionMediaFile("");
    setImageName("");
    setFile("");
    setFileExtensionType("");
    setSelectedImage(null);
    setLoading(false);
  };

  const [openSubModal, setOpenSubModal] = useState(false);
  const openSubModalCreate = () => {
    if (!selModuleDetails.moduleId) {
      toast.error("Please select a module first before creating a submodule !");
    } else {
      setOpenSubModal(true);
    }
  };
  const closeSubModal = () => {
    setOpenSubModal(false);
    setSubmoduleOrder("");
    setSubmoduleName("");
    setSubmoduleDuration("");
    setSdescription("");
    setFile("");
    setSelectedImage(null);
    setImageName("");
    setFileExtensionType("");
    setLoading(false);
  };

  const [openTopModal, setOpenTopModal] = useState(false);
  const openTopModalCreate = () => {
    if (!selSubModuleDetails.submoduleId) {
      toast.error("Please select a module first before creating a submodule !");
    } else {
      setOpenTopModal(true);
    }
  };
  const closeTopModal = () => {
    setOpenTopModal(false);
    setTopicOrder("");
    setTopicName("");
    setTopicDuration("");
    setTdescription("");
    setImageName("");
    setFile("");
    setFileExtensionType("");
    setSelectedImage(null);
    setLoading(false);
  };

  //Todo----------------------------------------------------------------------------
  // console.log("file-------------------->", file);
  // console.log("selectedImage-------------------->", selectedImage);
  // console.log("imageName-------------------->", imageName);

  console.log("updateData-------------------------->", updateData);
  const [loading, setLoading] = useState(false);

  return (
    <>
      <div>
        <MuiHeader header="Pedagogy/ 21st/ Tech Modules and Submodules" />
        <div style={{ marginTop: "80px" }}>
          <Modal
            open={openModal}
            onClose={closeModal}
            style={{ height: "70%", marginTop: "7%" }}
          >
            <Box
              sx={{
                ...style,
                height: "100%", // Make sure the Box takes full height
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  flexGrow: 1,
                  overflowY: "auto", // Enable vertical scrolling
                  padding: 2, // Add padding for spacing
                }}
              >
                <TextField
                  id="outlined-basic"
                  label="Order"
                  variant="outlined"
                  type="number"
                  InputProps={{
                    inputProps: {
                      max: 100,
                      min: 0,
                    },
                  }}
                  sx={{
                    width: 250,
                    marginTop: 2,
                    marginLeft: 4,
                  }}
                  size="small"
                  value={moduleorder}
                  onChange={moduleorder_select_onchange}
                />

                <TextField
                  id="outlined-basic"
                  label="Duration"
                  variant="outlined"
                  type="number"
                  InputProps={{
                    inputProps: {
                      max: 100,
                      min: 0,
                    },
                  }}
                  sx={{
                    width: 250,
                    marginTop: 2,
                    marginLeft: 4,
                  }}
                  size="small"
                  value={moduleDuration}
                  onChange={moduleDuration_select_onchange}
                />
                <TextField
                  id="outlined-multiline-static"
                  label="Module"
                  multiline
                  rows={2}
                  variant="outlined"
                  sx={{
                    width: 250,
                    marginTop: 2,
                    marginLeft: 4,
                  }}
                  size="small"
                  value={modulename}
                  onChange={module_create_onChange}
                />
                <br />

                <TextField
                  id="outlined-multiline-static"
                  label="Description"
                  multiline
                  rows={4}
                  value={mdescription}
                  onChange={change_DescriptionM}
                  sx={{
                    width: 250,
                    marginTop: 2,
                    marginLeft: 4,
                  }}
                />
                <div style={{ marginLeft: "33px", marginTop: "10px" }}>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                  {file && (
                    <img
                      src={file}
                      alt="Selected"
                      style={{
                        maxWidth: "100%",
                        marginTop: "10px",
                        marginLeft: "-15px",
                      }}
                    />
                  )}
                </div>
              </Box>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  padding: 2,
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    width: 70,
                    marginTop: 2,
                    marginBottom: 1,
                    marginRight: 1,
                  }}
                  onClick={closeModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    width: 70,
                    marginTop: 2,
                    marginBottom: 1,
                    marginRight: 1,
                  }}
                  onClick={handleModuleSave}
                  disabled={loading}
                >
                  {loading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    "SAVE"
                  )}
                </Button>
              </div>
            </Box>
          </Modal>

          <Modal open={openSubModal} onClose={closeSubModal}>
            <Box sx={style}>
              <TextField
                id="outlined-basic"
                label=" Order"
                sx={{
                  width: 250,
                  marginTop: 2,
                  marginLeft: 4,
                }}
                size="small"
                variant="outlined"
                type="number"
                InputProps={{
                  inputProps: {
                    max: 100,
                    min: 0,
                  },
                }}
                value={submoduleOrder}
                onChange={submoduleOrder_select_onChange}
              />

              <TextField
                id="outlined-basic"
                label="Duration"
                variant="outlined"
                type="number"
                InputProps={{
                  inputProps: {
                    max: 100,
                    min: 0,
                  },
                }}
                sx={{
                  width: 250,
                  marginTop: 2,
                  marginLeft: 4,
                }}
                size="small"
                value={submoduleDuration}
                onChange={submoduleDuration_select_onChange}
              />
              <TextField
                id="outlined-basic"
                label="SubModule"
                multiline
                rows={2}
                sx={{
                  width: 250,
                  marginTop: 2,
                  marginLeft: 4,
                }}
                size="small"
                variant="outlined"
                value={submoduleName}
                onChange={submoduleName_select_onChange}
              />
              <br />

              <TextField
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={4}
                value={sdescription}
                onChange={change_DescriptionS}
                sx={{
                  marginTop: 2,
                  width: 250,
                  marginLeft: 4,
                }}
              />

              <div style={{ display: "flex", justifyContent: "space-around" }}>
                <Button
                  variant="contained"
                  sx={{
                    width: 70,
                    marginTop: 2,
                    marginBottom: 1,
                    marginRight: 1,
                  }}
                  onClick={closeSubModal}
                >
                  Cancel
                </Button>

                <Button
                  variant="contained"
                  sx={{
                    width: 70,
                    marginTop: 2,
                    marginBottom: 1,
                    marginRight: 1,
                  }}
                  onClick={handleSubmoduleSave}
                >
                  SAVE
                </Button>
              </div>
            </Box>
          </Modal>
          <Modal open={openTopModal} onClose={closeTopModal}>
            <Box sx={style}>
              <TextField
                id="outlined-basic"
                label="Order"
                sx={{
                  width: 250,
                  marginTop: 2,
                  // marginBottom: 1,
                  // marginRight: 1,
                  marginLeft: 4,
                }}
                size="small"
                variant="outlined"
                type="number"
                InputProps={{
                  inputProps: {
                    max: 100,
                    min: 0,
                  },
                }}
                value={topicOrder}
                onChange={topicOrder_select_onchange}
              />

              <TextField
                id="outlined-basic"
                label="Duration"
                variant="outlined"
                type="number"
                InputProps={{
                  inputProps: {
                    max: 100,
                    min: 0,
                  },
                }}
                sx={{
                  width: 250,
                  marginTop: 2,
                  // marginBottom: 1,
                  // marginRight: 1,
                  marginLeft: 4,
                }}
                size="small"
                value={topicDuration}
                onChange={topicDuration_select_onchange}
              />
              <TextField
                sx={{
                  width: 250,
                  marginTop: 2,
                  // marginBottom: 1,
                  marginLeft: 4,
                }}
                size="small"
                id="outlined-basic"
                label="Topic "
                variant="outlined"
                value={topicName}
                onChange={topicName_select_onchange}
              />
              <br />

              <TextField
                id="outlined-multiline-static"
                label="Description"
                multiline
                rows={4}
                value={tdescription}
                onChange={change_DescriptionT}
                sx={{
                  width: 250,
                  marginTop: 2,
                  // marginBottom: 1,
                  marginLeft: 4,
                }}
              />

              <div style={{ display: "flex", justifyContent: "space-around" }}>
                <Button
                  variant="contained"
                  sx={{
                    width: 70,
                    marginTop: 2,
                    marginBottom: 1,
                    marginRight: 1,
                  }}
                  onClick={closeTopModal}
                >
                  Cancel
                </Button>

                <Button
                  variant="contained"
                  sx={{
                    width: 70,
                    marginTop: 2,
                    marginBottom: 1,
                    marginRight: 1,
                  }}
                  onClick={handleTopicSave}
                >
                  SAVE
                </Button>
              </div>
            </Box>
          </Modal>
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="demo-select-small">Language</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={preferedlanguage}
              label="Language"
              onChange={preflanguage_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {language_select_option_list.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
            <InputLabel id="demo-select-small">Usertype</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={usertype}
              label="Language"
              onChange={usertype_select_onchange}
            >
              {/* <MenuItem value="">None</MenuItem> */}
              {preferedlanguage
                ? usertype_select_option_list.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.text}
                    </MenuItem>
                  ))
                : null}
            </Select>
          </FormControl>

          <FormControl sx={{ m: 1, minWidth: 140 }} size="small">
            <InputLabel id="demo-select-small">Trainingtype</InputLabel>
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              value={programtype}
              label="Trainingtype"
              onChange={program_select_onchange}
            >
              <MenuItem value="">None</MenuItem>
              {preferedlanguage && usertype && trainingTypeArray
                ? trainingTypeArray.map((option) => (
                    <MenuItem
                      key={option.trainingType}
                      value={option.trainingType}
                    >
                      {option.trainingName}
                    </MenuItem>
                  ))
                : null}
            </Select>
          </FormControl>

          <Button
            onClick={navigate_to}
            variant="outlined"
            sx={{
              m: 1,
              minWidth: 90,

              marginTop: -8.8,
            }}
            size="small"
          >
            <UndoIcon
              style={{
                color: "orange",
              }}
            ></UndoIcon>
            BACK
          </Button>
        </div>
        {preferedlanguage && usertype && programtype ? (
          <div style={{ display: "flex" }}>
            <Button
              sx={{
                m: 2,
                border: "1px solid grey",
                borderRadius: "10px",
                width: "430px",
                backgroundColor: "lightblue",
              }}
              onClick={openModalCreate}
            >
              create New Module
            </Button>
            <Button
              sx={{
                m: 2,
                border: "1px solid grey",
                borderRadius: "10px",
                width: "410px",
                backgroundColor: "lightblue",
                marginLeft: "30px",
              }}
              onClick={openSubModalCreate}
            >
              create New SubModule
            </Button>
            <Button
              sx={{
                m: 2,
                border: "1px solid grey",
                borderRadius: "10px",
                width: "450px",
                backgroundColor: "lightblue",
                marginLeft: "30px",
              }}
              onClick={openTopModalCreate}
            >
              create New Topic
            </Button>
          </div>
        ) : null}

        {preferedlanguage && usertype && programtype ? (
          <div style={{ display: "flex" }}>
            <Box
              component="form"
              sx={{
                m: 2,
                border: "1px solid grey",
                borderRadius: "10px",
                width: "430px",
                backgroundColor: "lightblue",
              }}
              noValidate
              autoComplete="off"
            >
              <div>
                {modules && (
                  <div>
                    {modules && (
                      <div>
                        {modules.map((element, i) => (
                          <div
                            key={i}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              border: "1px solid black",
                              borderRadius: "5px",
                              padding: "10px",
                              marginBottom: "10px",
                              marginTop: "15px",
                            }}
                          >
                            <div style={{ width: "100%", textAlign: "center" }}>
                              <div
                                style={{
                                  maxHeight: "160px",
                                  maxWidth: "380px",
                                  // border: "black solid 2px",
                                  overflow: "auto",
                                  whiteSpace: "pre-wrap",
                                  marginTop: "10px",
                                  fontWeight: "bold",
                                }}
                              >
                                {element.moduleName}
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                width: "100%",
                                marginTop: "10px",
                              }}
                            >
                              <div style={{ width: "5%" }}>
                                {element.moduleOrder}.
                              </div>
                              <div style={{ width: "10%" }}>
                                {element.moduleDuration}mins
                              </div>
                              <div style={{ width: "10%" }}>
                                <Button
                                  // onClick={() => moduleEdit_clicked(element)}
                                  onClick={() => handleShowUpdate(element)}
                                >
                                  <EditIcon style={{ color: "blue" }} />
                                </Button>
                              </div>
                              <div style={{ width: "10%" }}>
                                <Button
                                  onClick={() => moduleDelete_clicked(element)}
                                >
                                  <DeleteIcon style={{ color: "red" }} />
                                </Button>
                              </div>
                            </div>
                            {element.moduleDescription && (
                              <div
                                style={{
                                  maxHeight: "160px",
                                  maxWidth: "300px",
                                  border: "black solid 2px",
                                  overflow: "auto",
                                  whiteSpace: "pre-wrap",
                                  marginTop: "10px",
                                }}
                              >
                                {element?.moduleDescription}
                              </div>
                            )}
                            <div
                              style={{
                                maxHeight: "160px",
                                maxWidth: "300px",
                                // border: "black solid 2px",
                                overflow: "auto",
                                whiteSpace: "pre-wrap",
                                marginTop: "10px",
                              }}
                            >
                              {/* {element.moduleImage} */}
                              {element?.moduleImage && (
                                <img
                                  src={getMediaUrl(element?.moduleImage)}
                                  alt="Preview"
                                  width={100}
                                  height={80}
                                />
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </Box>

            <Box
              component="form"
              style={styles.selects}
              noValidate
              autoComplete="off"
            >
              <div>
                <FormControl
                  sx={{ marginLeft: 4, width: 150, marginTop: 2 }}
                  size="small"
                >
                  <InputLabel id="demo-select-small">Modules</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={selModuleDetails.moduleId}
                    label="Modules"
                    onChange={module_select_onchange}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>

                    {modules
                      ? modules.map((element) => (
                          <MenuItem key={element.moduleId} value={element}>
                            {element.moduleName}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </div>

              <div style={{ marginLeft: 140, marginTop: 63 }}>
                <Box
                  style={{
                    width: "410px",
                    marginLeft: "-141px",
                  }}
                >
                  {submodules && (
                    <div>
                      {submodules && (
                        <div>
                          {submodules.map((element, i) => (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                border: "1px solid black",
                                borderRadius: "5px",
                                padding: "10px",
                                marginBottom: "10px",
                                marginTop: "15px",
                              }}
                            >
                              <div
                                style={{ width: "90%", textAlign: "center" }}
                              >
                                <div
                                  style={{
                                    maxHeight: "160px",
                                    maxWidth: "380px",
                                    // border: "black solid 2px",
                                    overflow: "auto",
                                    whiteSpace: "pre-wrap",
                                    marginTop: "10px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {element.submoduleName}
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  width: "100%",
                                  marginTop: "10px",
                                }}
                              >
                                <div style={{ width: "5%" }}>
                                  {element.submoduleOrder}.
                                </div>
                                <div style={{ width: "10%" }}>
                                  {element.submoduleDuration}mins
                                </div>
                                <div style={{ width: "10%" }}>
                                  <Button
                                    onClick={() =>
                                      submoduleEdit_clicked(element)
                                    }
                                  >
                                    <EditIcon style={{ color: "blue" }} />
                                  </Button>
                                </div>
                                <div style={{ width: "10%" }}>
                                  <Button
                                    onClick={() =>
                                      submoduleDelete_clicked(element)
                                    }
                                  >
                                    <DeleteIcon style={{ color: "red" }} />
                                  </Button>
                                </div>
                              </div>
                              {element.submoduleDescription && (
                                <div
                                  style={{
                                    maxHeight: "160px",
                                    maxWidth: "300px",
                                    border: "black solid 2px",
                                    overflow: "auto",
                                    whiteSpace: "pre-wrap",
                                    marginTop: "10px",
                                  }}
                                >
                                  {element.submoduleDescription}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </Box>
              </div>
            </Box>

            <Box
              component="form"
              style={styles.select}
              noValidate
              autoComplete="off"
            >
              <div>
                <FormControl
                  sx={{ marginLeft: 4, width: 140, marginTop: 2 }}
                  size="small"
                >
                  <InputLabel id="demo-select-small">Sub-Modules</InputLabel>
                  <Select
                    labelId="demo-select-small"
                    id="demo-select-small"
                    value={selSubModuleDetails.submoduleid}
                    label="Sub-Modules"
                    onChange={submodule_select_onchange}
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {submodules
                      ? submodules.map((option) => (
                          <MenuItem key={option.submoduleId} value={option}>
                            {option.submoduleName}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </div>

              <div style={{ marginLeft: 140, marginTop: 63 }}>
                <Box
                  style={{
                    width: "418px",
                    marginLeft: "-130px",
                  }}
                >
                  {
                    <div>
                      {
                        <div>
                          {topics.map((element, i) => (
                            <div
                              key={i}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                border: "1px solid black",
                                borderRadius: "5px",
                                padding: "10px",
                                marginBottom: "10px",
                                marginTop: "15px",
                              }}
                            >
                              <div
                                style={{ width: "100%", textAlign: "center" }}
                              >
                                <div
                                  style={{
                                    maxHeight: "160px",
                                    maxWidth: "380px",
                                    // border: "black solid 2px",
                                    overflow: "auto",
                                    whiteSpace: "pre-wrap",
                                    marginTop: "10px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {element.topicName}
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  width: "100%",
                                  marginTop: "10px",
                                }}
                              >
                                <div style={{ width: "5%" }}>
                                  {element.topicOrder}.
                                </div>
                                <div style={{ width: "10%" }}>
                                  {element.topicDuration}mins
                                </div>
                                <div style={{ width: "10%" }}>
                                  <Button
                                    onClick={() => topicEdit_clicked(element)}
                                  >
                                    <EditIcon style={{ color: "blue" }} />
                                  </Button>
                                </div>
                                <div style={{ width: "10%" }}>
                                  <Button
                                    onClick={() => topicDelete_clicked(element)}
                                  >
                                    <DeleteIcon style={{ color: "red" }} />
                                  </Button>
                                </div>
                              </div>
                              {element.topicDescription && (
                                <div
                                  style={{
                                    maxHeight: "160px",
                                    maxWidth: "300px",
                                    border: "black solid 2px",
                                    overflow: "auto",
                                    whiteSpace: "pre-wrap",
                                    marginTop: "10px",
                                  }}
                                >
                                  {element.topicDescription}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      }
                    </div>
                  }
                </Box>
              </div>
            </Box>
          </div>
        ) : null}

        <Modal
          open={showUpdate}
          //onClose={handleCloseUpdate}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <FormControl sx={{ m: 1, minWidth: 300 }} size="small">
              <Grid
                item
                xs={12}
                md={6}
                style={{ overflowY: "auto", maxHeight: "400px" }}
              >
                <Box sx={{ flexGrow: 1 }}>
                  <Grid container spacing={2} style={{ marginTop: 1 }}>
                    <Grid item xs={6} md={6}>
                      <TextField
                        id="outlined-basic"
                        label="module order"
                        variant="outlined"
                        value={updateData.moduleOrder}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            moduleOrder: e.target.value,
                          })
                        }
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} style={{ marginTop: 1 }}>
                    <Grid item xs={6} md={6}>
                      <TextField
                        id="outlined-basic"
                        label="module name"
                        variant="outlined"
                        value={updateData.moduleName}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            moduleName: e.target.value,
                          })
                        }
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} style={{ marginTop: 1 }}>
                    <Grid item xs={6} md={6}>
                      <TextField
                        id="outlined-basic"
                        label="module duration"
                        variant="outlined"
                        value={updateData.moduleDuration}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            moduleDuration: e.target.value,
                          })
                        }
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2} style={{ marginTop: 1 }}>
                    <Grid item xs={6} md={6}>
                      <TextField
                        id="outlined-basic"
                        label="module description"
                        variant="outlined"
                        value={updateData.moduleDescription}
                        onChange={(e) =>
                          setUpdateData({
                            ...updateData,
                            moduleDescription: e.target.value,
                          })
                        }
                      />
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={6}
                    style={{ overflowY: "auto", maxHeight: "400px" }}
                  >
                    {updateData.moduleImage ? (
                      <Button
                        variant="contained"
                        style={{ backgroundColor: "red" }}
                        onClick={() => deleteImageForUpdate(updateData)}
                      >
                        Delete Image
                      </Button>
                    ) : (
                      <input
                        type="file"
                        accept="image/*"
                        onChange={handleImageChange}
                      />
                    )}
                    {file || updateData.moduleImage ? (
                      <img
                        src={
                          file
                            ? file
                            : updateData.moduleImage
                            ? getMediaUrl(updateData.moduleImage)
                            : ""
                        }
                        alt="Image"
                        style={{ maxWidth: "100%", marginTop: "10px" }}
                      />
                    ) : null}
                  </Grid>
                </Box>
              </Grid>
            </FormControl>

            <Button
              variant="outlined"
              style={{ marginLeft: 12, marginTop: 30 }}
              onClick={handleCloseUpdate}
            >
              Close
            </Button>
            <Button
              variant="contained"
              style={{ marginLeft: 12, marginTop: 30 }}
              onClick={() => handleUpdateChange(updateData)}
              disabled={updateData.moduleImage ? false : file ? false : true}
            >
              Update
            </Button>
          </Box>
        </Modal>
      </div>
      <ToastContainer />
    </>
  );
}

export default PptModulesPage;
const styles = {
  select: {
    border: "1px solid grey",
    borderRadius: "10px",
    marginTop: "15px",
    marginBottom: "5px",
    marginLeft: "35px",
    width: "462px",
    // marginRight: "5px",
    backgroundColor: "lightblue",
  },
  selects: {
    border: "1px solid grey",
    borderRadius: "10px",
    marginTop: "15px",
    marginBottom: "5px",
    marginLeft: "30px",
    width: "420px",
    // marginRight: "5px",
    backgroundColor: "lightblue",
  },
};
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  overflowY: "auto",
};
